<template>
	<div class="stock-modal" :class="usePadding">
		<a v-if="! onlyShowIcon" @click="isOpen = true" class="hidden-xs stock-small">
			<stock-row store="download" :product="product" :stock="product.stock" v-if="product.stock.download" :release="product.release" size="small" />
			<template v-else>
				<stock-row :class="enlargedWebStock ? 'web-stock' : null" store="web" :name="t('STORE.WEB_STOCK')" :product="product" :stock="product.stock" :release="product.release" size="small" />
				<hr style="margin: 0" class="starred-stores-hr" v-if="storeSuggestions.favourites.length">
				<stock-row v-for="store in storeSuggestions.favourites" :key="store" :store="store" :product="product" :stock="product.stock" :release="product.release" size="small" />
				<hr style="margin: 0" v-if="storeSuggestions.suggestions.length">
				<stock-row v-for="store in storeSuggestions.suggestions" :key="store" :store="store" :product="product" :stock="product.stock" :release="product.release" size="small" />
				<div class="show-all-stock">
					<span class="glyphicon glyphicon-plus" /> Visa alla butiker
				</div>
			</template>
		</a>

		<!-- @TODO downloads needs to be displayed -->
		<a :class="{'visible-xs': ! onlyShowIcon}" style="z-index: 1; " class="compact-stock-link" @click="isOpen = true">
			<div class="stock-bar-wrapper" :class="stockClass">
				<div v-if="product.stock.download" class="pull-right">
					<span>Download&nbsp;</span>
					<stock-icon class="pull-right mt-0" :product="product" :stock="product.stock" :release="product.release" :store="'download'" />
				</div>
				<template v-else>
					<div id="web_stock" :title="this.webTitleText(product)">
						&nbsp;
						<span class="hidden-xs-grid hidden-xs-search pull-left">{{ t('STORE.WEB_STOCK') }}</span>
						<span class="hidden visible-xs-grid hidden-xs-search pull-left">{{ t('STORE.WEB_STOCK_COMPACT') }}</span>
						&nbsp;
						<stock-icon class="pull-right mt-0" :product="product" :stock="product.stock" :release="product.release" :store="'web'" />
					</div>
					<div id="boutique_stock" :title="this.boutiqueTitleText(product)">
						<span class="pull-left hidden-xs-search">{{t('STORE.BOUTIQUE_STOCK')}}&nbsp;</span>
						<div v-if="calculateStockDisplays" class="stock-favorite pull-right mr-0">
							<span v-for="index in this.userSettings.myStores" :key="'favorite_stores_'+index" :class="{'stock-in-favourite': stockFavouriteStores.indexOf(index) !== -1 }" />
						</div>
						<progress-bar v-else class="mb-0 mt-3 progress relative progress-stock pull-right" :class="{'progress-out-of-stock': this.stockPercentage <= 0 && isReleased(product.release)}" :value="valueForProgressBar()" text=""></progress-bar>
					</div>
				</template>
			</div>
		</a>

		<modal v-model="isOpen">
			<div v-if="isOpen && ! product.stock.download" class="stock-modal-content" style="white-space: normal;">
				<ximg
					class="pull-left m-4"
					:src="productImageSrc"
					:ariaLabel="product.name + ' product image'"
					role="img"
				/>
				<h2 class="level-three-heading mt-4">
					<router-link class="secondary-link" :to="productPath">{{ product.name }}</router-link>
				</h2>

				<div class="clearfix" />
				<div class="p-2 small">{{ t('STOCK.PICK_STORES_TO_SHOW') }}</div>

				<table>
					<stock-row class="web-stock" :name="t('STORE.WEB_STOCK')" :product="product" :stock="product.stock" size="large" store="web" :release="product.release" no-star />
					<template v-if="storeSuggestions.suggestions.length">
						<tr><th colspan="3"><hr class="mb-3"></th></tr>
						<stock-row v-for="store in storeSuggestions.suggestions" :product="product" :key="store" :store="store" :stock="product.stock" :release="product.release" no-star  />
					</template>
				</table>
				<!-- Store suggestions -->
				<hr />
				<template v-for="(group, index) in userSettings.storeGroupFormat">
					<table :key="'group-' + index + '-name'">
						<tr>
						<th colspan="3">{{ t(group.name) }}</th>
						</tr>
					</table>
					<table :key="'group-' + index + '-store'">
						<template v-for="(store, index) in group.stores">
							<tr v-if="isNaN(store)" :key="'store-group-' + index">
								<td colspan="3" class="store-group-label">
									{{ store }}
								</td>
							</tr>
							<stock-row v-else :key="'store-' + store + '-index-' + index" :store="store" :stock="product.stock" size="large" :product="product" :release="product.release" />
						</template>
					</table>
					<hr :key="'group-' + index + '-line'"/>
				</template>
				<em>Du kan välja upp till 3 butiker</em>
			</div>
		</modal>
	</div>
</template>

<script>
import { urlFormat, getStoreSuggestions, shouldShowStock, isProductReleased, releaseToString } from 'utils';
import router from 'router';
import store from 'datastore';
import { mapState } from 'vuex';
import { t } from 'datastore/i18n';

export default {
	store,
	props: {
		product: {
			type: Object,
			required: true,
		},
		maxStoreSuggestions: {
			type: Number,
			default: 4,
		},
		enlargedWebStock: {
			type: Boolean,
			default: true,
		},
		iconOnly: {
			default: null,
		},
		listType: {
			default: 'compactList',
		},
	},
	data () {
		return {
			isOpen: false,
			stockFavouriteStores: [],
			stockPercentage: 0,
			numberRegularStores: 25,
			numberStoresInStock: 0,
		};
	},
	methods: {
		t,
		valueForProgressBar() {
			if (! this.shouldShowStock) {
				return 0;
			} else if (this.stockPercentage <= 0 && this.isReleased(this.product.release)) {
				return 1;
			} else {
				return this.stockPercentage;
			}
		},
		webTitleText (product) {
			if (! this.shouldShowStock) {
				return 'Ej i lager';
			} else if (! this.isReleased(product.release)) {
				return this.releaseDate(product.release);
			} else if (product.stock['web'] > 0) {
				return t('STOCK.WEB_HAS_STOCK');
			} else {
				return t('STOCK.WEB_EMPTY');
			}
		},
		boutiqueTitleText (product) {
			if (! this.isReleased(product.release)) {
				return this.releaseDate(product.release);
			} if (this.stockFavouriteStores.length >= 1) {
				return t('STOCK.IN_FAVOURITE_STORES', this.stockFavouriteStores.length);
			} else if (this.numberStoresInStock === 25) {
				return t('STOCK.IN_ALL_STORES');
			} else if (this.stockPercentage <= 0) {
				return t('STOCK.EMPTY');
			} else {
				if (this.numberStoresInStock > 1) {
					return t('STOCK.IN_STOCK_MULTIPLE_STORES', this.numberStoresInStock);
				} else {
					return t('STOCK.IN_STOCK_ONE_STORE');
				}
			}
		},
		isReleased (release) {
			if (! release) {
				return true;
			}

			return isProductReleased(release);
		},
		releaseDate (release) {
			if (! release) {
				return t('STOCK.NOT_RELEASED');
			}

			return releaseToString(release);
		},
	},
	computed: {
		shouldShowStock() {
			return shouldShowStock(this.product, this.user);
		},
		onlyShowIcon () {
			return this.iconOnly !== null;
		},
		productPath () {
			return router.route({
				name: 'product',
				params: {
					id: this.product.id,
					name: urlFormat(this.product.name),
				},
			});
		},
		productImageSrc () {
			return '/images/product/' + this.product.id + '?trim&h=80';
		},
		storeSuggestions () {
			return getStoreSuggestions(
				this.product.stock,
				this.user.storeSuggestions,
				this.userSettings.myStores,
				this.maxStoreSuggestions
			);
		},
		stockClass () {
			switch (this.listType) {
				case 'list':
					return 'stock-type-list';
				case 'compactList':
					return 'stock-type-compact-list';
				case 'grid':
					return 'stock-type-grid';
				case 'searchList':
					return 'stock-type-search';
				case 'tip':
					return 'stock-type-tip';
				default:
					return 'stock-type-compact-list';
			}
		},
		usePadding () {
			if (this.listType === 'compactList') {
				return 'pl-5-sm';
			} else if (this.listType === 'searchList') {
				return '';
			} else {
				return 'pl-5';
			}
		},
		calculateStockDisplays () {
			// return true if we should display heart rating, else return false
			const suggestions = getStoreSuggestions(
				this.product.stock,
				this.user.storeSuggestions,
				[],
				this.numberRegularStores + this.userSettings.myStores.length
			);

			this.stockFavouriteStores = [];
			this.stockPercentage = 0.0;

			if (! this.isReleased(this.product.release) || ! this.shouldShowStock) {
				return false;
			}

			if (this.userSettings.myStores.length) {
				// Check if the product is in stock in our favorite stores
				for (const store of this.userSettings.myStores) {
					if (this.product.stock[store] > 0) {
						this.stockFavouriteStores.push(store);
					}
				}

				if (this.stockFavouriteStores.length) {
					return true;
				}
			}

			// The weight list is sorted by weight, the heaviest item is the first one
			const biggest = this.user.storeWeights[0];

			// Calculate a fraction based on the biggest weight,
			// this will enable us to get a 1-0 represention of the weights, where 1 is the heavist, and 0 is no weight
			const distanceFractions = {};
			for (const [index, weight] of this.user.storeWeights.entries()) {
				// Fraction of biggest weight
				const fraction = weight / biggest;
				// Store in lookup array with store id as index for easy access later
				distanceFractions[this.user.storeSuggestions[index]] = fraction;
			}

			// Calculate the stock percentage
			const piece = (1.0 / this.numberRegularStores);
			this.numberStoresInStock = 0;
			for (const store of suggestions.suggestions) {
				if (store === 'supplier' || store === 9999 || this.product.stock[store] <= 0) {
					continue;
				}

				this.numberStoresInStock++;
				this.stockPercentage += piece;
			}

			// Add weights if needed, only add untill we're 1.0
			const extra_piece = piece * 5;
			for (const store of suggestions.suggestions) {
				if (this.stockPercentage >= 1.0) {
					// cap'n break
					this.stockPercentage = 1.0;
					break;
				}

				if (store === 'supplier' || store === 9999 || this.product.stock[store] <= 0) {
					continue;
				}

				if (distanceFractions[store] === undefined) {
					continue;
				}

				// Add extra weights based on relative weight
				this.stockPercentage += (extra_piece * distanceFractions[store]);
			}

			// Round
			const tmp = this.stockPercentage;
			this.stockPercentage = Number(tmp.toFixed(2));

			return false;
		},
		...mapState({
			user: state => state.user,
			userSettings: state => state.userSettings,
		}),
	},
};
</script>
